import { styled } from "@mui/system";
import Button from "@mui/material/Button";

export const QuestionCOntainer = styled("div")({
  width: "60vw",
  margin: "0 auto",
  backgroundColor: "#F9FAFB",
  borderRadius: "15px 0 15px 0",
  height: "50vh",
  padding: "30px 50px",
  boxShadow: "2px 2px 6px rgba(12, 49, 57, 0.2)",

  "@media (max-width: 968px)": {
    width: "80vw",
  },
  "@media (max-width: 670px)": {
    padding: "20px 30px",
  },
  "@media (max-width: 642px)": {
    width: "90vw",
  },

  // "@media (max-width: 566px)": {
  //   display: "flex",
  //   flexDirection: "column",
  //   alignItems: "center",
  // },
});

export const QuestionnaireTitle = styled("h1")({
  fontWeight: 500,
  textAlign: "center",
  fontSize: 30,
  color: "#000000",
  // marginTop: "3%",

  "@media (max-width: 600px)": {
    fontSize: 20,
  },
});

export const Title = styled("h2")({
  fontWeight: 500,
  textAlign: "center",
  fontSize: 20,
  color: "#000000",

  "@media (max-width: 600px)": {
    fontSize: 20,
  },
});

export const QuestionnaireDetailContainer = styled("div")({
  width: "70%",
  margin: "0 auto",

  "@media (max-width: 472px)": {
    // width: "70%",
  },
});

export const QuestionnaireDetail = styled("p")({
  textAlign: "center",
  fontWeight: 400,
  fontSize: 18,
  lineHeight: 1.2,
  marginTop: "7%",
  // width: '60%'

  "@media (max-width: 600px)": {
    fontSize: 14,
  },
});

export const ButtonBox = styled("div")({
  display: "flex",
  flexDirection: "row",
  justifyContent: "center",
  marginTop: 40,
});

export const StartBtn = styled(Button)({
  color: "white",
  backgroundColor: "#5E9C98",
  width: "350px",
  padding: "16px 0",
  borderRadius: 30,
  fontSize: "1.2rem",
  boxShadow: "1px 2px 6px rgba(0, 0, 0, 0.2)",
  textTransform: "capitalize",
  marginBottom: "100px",

  "&:hover": {
    backgroundColor: "#5E9C98",
  },
  "@media (max-width: 440px)": {
    width: "280px",
  },
});

export const OptionsContainer = styled("div")({
  display: "flex",
  justifyContent: "center",
  marginTop: "3%",
  flexWrap: "wrap",

  "@media (max-width: 566px)": {
    justifyContent: "flex-start",
    padding: "0 25%",
  },

  "@media (max-width: 431px)": {
    justifyContent: "flex-start",
    padding: "0 20%",
  },

  "@media (max-width: 363px)": {
    alignItems: "flex-start",
    padding: "0 10%",
    flexDirection: "column",
  },
});

export const ProgressContainer = styled("div")({
  marginLeft: "auto",
  width: 80,
  height: 80,

  "@media (max-width: 552px)": {
    margin: "0 auto",
    width: 60,
    height: 60,
    marginBottom: 30,
  },
});

export const ProgressText = styled("p")({
  fontSize: 14,
  marginTop: -10,
});

export const ButtonContainer = styled("div")({
  width: "40vw",
  display: "flex",
  alignItems: "center",
  justifyContent: "space-around",
  margin: "50px auto 0 auto",
  // padding: "0 100px",
  marginBottom: '80px',

  "@media (max-width: 968px)": {
    width: "80vw",
  },

  "@media (max-width: 818px)": {
    padding: "20px 30px",
  },
  "@media (max-width: 642px)": {
    width: "90vw",
    margin: "15px auto 0 auto",
  },

  "@media (max-width: 492px)": {
    width: "100vw",
  },
});

export const NextBtn = styled(Button)({
  width: 260,
  borderRadius: 30,
  backgroundColor: "#5E9C98",
  color: "#FFFFFF",
  padding: "13px 0",
  boxShadow: "1px 2px 6px rgba(0, 0, 0, 0.2)",

  "&:hover": {
    backgroundColor: "#5E9C98",
  },

  "@media (max-width: 918px)": {
    width: 220,
  },
  "@media (max-width: 584px)": {
    width: 180,
    padding: "8px 0",
  },
  "@media (max-width: 430px)": {
    width: 140,
    padding: "6px 0",
  },
  "@media (max-width: 378px)": {
    width: 120,
    padding: "4px 0",
  },
});

export const PrevBtn = styled(Button)({
  width: 260,
  borderRadius: 30,
  backgroundColor: "transparent",
  color: "#000000",
  border: "2px solid #000000",
  padding: "10px 0",
  "&:hover": {
    backgroundColor: "transparent",
    color: "#000",
  },
  "@media (max-width: 918px)": {
    width: 220,
  },
  "@media (max-width: 584px)": {
    width: 180,
    padding: "8px 0",
  },

  "@media (max-width: 430px)": {
    width: 140,
    padding: "6px 0",
  },
  "@media (max-width: 378px)": {
    width: 120,
    padding: "4px 0",
  },
});

export const ImgBox = styled("div")({
  display: "flex",
  padding: "40px",
  alignItems: "baseline",
  // width: "max-content",
  // margin: "0 auto",
});

export const ImgIcon = styled("img")({
  marginRight: "45px",
  // height: "60px",
  // width: "60px",
});
